$(function () {

    /**
     * SEO : NEWSLETTER
     */

    $('#newsletter').on('submit', function(e) {
        e.preventDefault();

        var recaptcha_key = $(e.currentTarget).attr('data-sitekey');
        var message = $('.footer__newsletter__messages');

        if (recaptcha_key) {
            grecaptcha.ready(function() {
                grecaptcha.execute(recaptcha_key, {action: 'submit'}).then(function(token) {
                    $.ajax({
                        'url': $(e.target).attr('action'),
                        'type': $(e.target).attr('method'),
                        'data': $(e.target).serialize(),
                        'success': function (data) {
                            message.addClass('has-message');
                            if (data.success) {
                                message.html('<div class="alert alert-success"><ul><li>' + data.message + '</li></ul></div>');
                                if (data.datalayer) {
                                    $.fn.pushDatalayer(data.datalayer);
                                }
                            } else {
                                message.html('<div class="alert alert-info"><ul><li>' + data.error + '</li></ul></div>');
                            }
                        },
                        'error': function (e) {
                            console.error('Something wrong!', e);
                            message.html('<div class="alert alert-danger"><ul><li>' + JSON.parse(e.responseText).errors.email[0] + '</li></ul></div>');
                        }
                    });
                });
            });
        } else {
            message.html('<div class="alert alert-danger"><ul><li>Clé REcaptcha manquante.</li></ul></div>');
        }
    });

    /**
     * FIN - SEO : NEWSLETTER
     */

});

